import { render, staticRenderFns } from "./Palette.vue?vue&type=template&id=4cbbb1f6&scoped=true&"
import script from "./Palette.vue?vue&type=script&lang=js&"
export * from "./Palette.vue?vue&type=script&lang=js&"
import style0 from "./Palette.vue?vue&type=style&index=0&id=4cbbb1f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbbb1f6",
  null
  
)

export default component.exports